import React from 'react';
import { cx } from '@emotion/css';

import { Container, FaceButtonColor, FaceButtonSize, FaceButtonIcon } from './styles';
import { Typography } from '@common/styles';

function getTypoSize(size?: FaceButtonSize) {
  switch (size) {
    case FaceButtonSize.S13_H32:
    case FaceButtonSize.S13_H40:
      return Typography.BODY_13_BOLD;
    case FaceButtonSize.S15_H40:
    case FaceButtonSize.S15_H44:
    case FaceButtonSize.S15_H48:
      return Typography.BODY_15_BOLD;
    default:
      return null;
  }
}

export interface FaceButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  color_type?: FaceButtonColor;
  size_type?: FaceButtonSize;
  icon_type?: FaceButtonIcon;
}

export const FaceButton: React.FC<React.PropsWithChildren<FaceButtonProps>> = ({
  children,
  color_type,
  size_type,
  icon_type,
  ...otherProps
}) => {
  return (
    <Container colorType={color_type} sizeType={size_type} {...otherProps}>
      {!!icon_type && <figure className={cx('icon', icon_type)} />}
      {children && <span className={cx('text', getTypoSize(size_type))}>{children}</span>}
    </Container>
  );
};

export { FaceButtonColor, FaceButtonIcon, FaceButtonSize };
